import { computed } from 'vue'
import { PLAYLIST_VIDEOS_MAX_NUM } from '@/services/constants'
import { addFolderVideosToPlaylist } from '@/services/utils'

export function useFoldersPlaylist() {
  const getDisabledTooltip = (folder: { number_of_videos?: number }) => {
    return computed(() => {
      const videoCount = folder?.number_of_videos ?? 0
      if (videoCount === 0) {
        return 'folder-is-empty'
      }
      if (videoCount > PLAYLIST_VIDEOS_MAX_NUM) {
        return 'folder-exceeds-playlist-limit'
      }
      return ''
    })
  }

  const getIsFolderEmpty = (folder: { number_of_videos?: number }) => {
    return computed(() => (folder?.number_of_videos ?? 0) === 0)
  }

  const getIsVideosExceedLimit = (folder: { number_of_videos?: number }) => {
    return computed(() => (folder?.number_of_videos ?? 0) > PLAYLIST_VIDEOS_MAX_NUM)
  }

  const createAddFolderToPlaylist = (folder: { id: number; number_of_videos?: number }, organizationId: number) => {
    return async () => {
      const isEmpty = getIsFolderEmpty(folder).value
      const exceedsLimit = getIsVideosExceedLimit(folder).value
      if (isEmpty || exceedsLimit || !folder.id) {
        return
      }
      await addFolderVideosToPlaylist(+folder.id, folder.number_of_videos ?? 0, organizationId, { folderId: folder.id })
    }
  }

  return {
    getDisabledTooltip,
    getIsFolderEmpty,
    getIsVideosExceedLimit,
    createAddFolderToPlaylist
  }
}
